var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"empty-table",attrs:{"colspan":"20"}},[_c('i',{staticClass:"fas fa-inbox d-block"}),_vm._v(" "+_vm._s(_vm.emptyTableText)+" "),_c('p',[_vm._v(_vm._s(_vm.emptyTableSubText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }